(() => {const bfDesktopMin=document.querySelector('[data-bf-catalogue-host]')?1200:1025;
(()=>{const el=document.querySelector('cb-visual-catalogue'),mount=document.querySelector('[data-bf-catalogue-host]')||(matchMedia(`(min-width:${bfDesktopMin}px)`).matches?document.querySelector('#HeaderNavigation'):document.body);if(el&&mount&&el.parentElement!==mount)mount.append(el);})();
(() => {
  if (customElements.get('cb-visual-catalogue')) return;
  class VisualCatalogue extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.bindGlobalEvents(); return; }
      this.ready = true;
      this.flyout = this.querySelector('.cb-catalogue__flyout');
      this.dialog = this.querySelector('dialog');
      this.rootView = this.querySelector('[data-mobile-root]');
      this.mobileGroup = this.querySelector('[data-mobile-group]');
      this.current = 'fully-custom';
      this.pointerTimer = null;
      this.hoverOpened = false;
      const logo = null;
      if (logo) this.querySelector('.cb-catalogue__brand').append(logo.cloneNode(true));
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-catalogue-open]');
        const rail = event.target.closest('[data-catalogue-group]');
        const mobile = event.target.closest('[data-mobile-open]');
        if (trigger) {
          const group = trigger.dataset.catalogueOpen;
          if (!this.flyout.hidden && trigger.getAttribute('aria-expanded') === 'true' && !this.hoverOpened) this.closeDesktop(true);
          else { this.openDesktop(group === 'all' ? this.current : group, trigger); this.hoverOpened = false; }
        } else if (rail) { this.hoverOpened = false; this.selectGroup(rail.dataset.catalogueGroup); }
        else if (mobile) this.openMobileGroup(mobile.dataset.mobileOpen);
        else if (event.target.closest('[data-catalogue-close]')) this.closeDesktop(true);
        else if (event.target.closest('[data-mobile-toggle]')) this.openMobile();
        else if (event.target.closest('[data-mobile-close]')) this.dialog.close();
        else if (event.target.closest('[data-mobile-back]')) this.showMobileRoot(true);
      });
      this.querySelectorAll('[data-catalogue-open]').forEach(trigger => trigger.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia(`(min-width:${bfDesktopMin}px) and (hover:hover)`).matches) return;
        clearTimeout(this.pointerTimer);
        this.pointerTimer = setTimeout(() => { this.openDesktop(trigger.dataset.catalogueOpen === 'all' ? this.current : trigger.dataset.catalogueOpen, trigger); this.hoverOpened = true; }, 130);
      }));
      this.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.pointerTimer);
        this.pointerTimer = setTimeout(() => this.closeDesktop(false), 220);
      });
      this.addEventListener('pointerenter', () => clearTimeout(this.pointerTimer));
      this.querySelector('[role=tablist]').addEventListener('keydown', event => {
        if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
        const buttons = [...this.querySelectorAll('[data-catalogue-group]')];
        let index = buttons.indexOf(event.target);
        if (index < 0) return;
        event.preventDefault();
        index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].focus();
        this.selectGroup(buttons[index].dataset.catalogueGroup);
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cb-catalogue-mobile-open');
        this.querySelector('[data-mobile-toggle]').setAttribute('aria-expanded','false');
        this.showMobileRoot(false);
      });
      this.onKey = event => { if (event.key === 'Escape' && !this.flyout.hidden) this.closeDesktop(true); };
      this.onPointer = event => { if (!this.contains(event.target)) this.closeDesktop(false); };
      this.onScroll = () => this.closeDesktop(false);
      this.onResize = () => {
        this.closeDesktop(false);
        if (matchMedia(`(min-width:${bfDesktopMin}px)`).matches && this.dialog.open) this.dialog.close();
      };
      this.bindGlobalEvents();
      this.selectGroup(this.current, false);
    }
    bindGlobalEvents() {
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('pointerdown', this.onPointer);
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onResize, {passive:true});
    }
    loadGroupArt(group) {
      const panel = this.querySelector('[data-panel="'+group+'"]');
      if (!panel?.dataset.artHref || this.querySelector('link[data-cb-art="'+group+'"]')) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = panel.dataset.artHref;
      link.dataset.cbArt = group;
      link.addEventListener('error', () => link.remove(), {once:true});
      this.append(link);
    }
    selectGroup(group, loadArt = true) {
      if (!this.querySelector('[data-panel="'+group+'"]')) return;
      if (loadArt) this.loadGroupArt(group);
      this.current = group;
      this.querySelectorAll('[data-catalogue-group]').forEach(button => button.setAttribute('aria-selected',String(button.dataset.catalogueGroup === group)));
      this.querySelectorAll('[data-panel]').forEach(panel => {panel.hidden = panel.dataset.panel !== group;});
    }
    openDesktop(group, trigger) {
      if (!matchMedia(`(min-width:${bfDesktopMin}px)`).matches) return;
      clearTimeout(this.pointerTimer);
      this.selectGroup(group);
      this.opener = trigger;
      this.style.setProperty('--cb-catalogue-top',Math.max(0,(this.closest('.bf-compact-header-section')||this).getBoundingClientRect().bottom)+'px');
      const search = document.querySelector('.cb-header-search[open]');
      if (search) search.removeAttribute('open');
      this.flyout.hidden = false;
      this.querySelectorAll('[data-catalogue-open]').forEach(button => button.setAttribute('aria-expanded',String(button === trigger)));
    }
    closeDesktop(restoreFocus) {
      clearTimeout(this.pointerTimer);
      if (!this.flyout || this.flyout.hidden) return;
      this.flyout.hidden = true;
      this.hoverOpened = false;
      this.querySelectorAll('[data-catalogue-open]').forEach(button => button.setAttribute('aria-expanded','false'));
      if (restoreFocus && this.opener) this.opener.focus();
    }
    openMobile() {
      this.closeDesktop(false);
      this.showMobileRoot(false);
      this.dialog.showModal();
      document.documentElement.classList.add('cb-catalogue-mobile-open');
      this.querySelector('[data-mobile-toggle]').setAttribute('aria-expanded','true');
      this.querySelector('[data-mobile-close]').focus();
    }
    showMobileRoot(focus) {
      this.rootView.hidden = false;
      this.mobileGroup.hidden = true;
      this.querySelector('.cb-catalogue__mobile-scroll').scrollTop = 0;
      if (focus && this.mobileOrigin) this.mobileOrigin.focus();
    }
    openMobileGroup(group) {
      const content = this.querySelector('[data-panel="'+group+'"]');
      if (!content) return;
      this.loadGroupArt(group);
      this.mobileOrigin = this.querySelector('[data-mobile-open="'+group+'"]');
      this.mobileGroup.querySelector('[data-mobile-content]').innerHTML = content.innerHTML;
      this.mobileGroup.querySelectorAll('[data-catalogue-close]').forEach(button => button.remove());
      this.rootView.hidden = true;
      this.mobileGroup.hidden = false;
      this.querySelector('.cb-catalogue__mobile-scroll').scrollTop = 0;
      this.mobileGroup.querySelector('[data-mobile-back]').focus();
    }
    disconnectedCallback() {
      clearTimeout(this.pointerTimer);
      document.removeEventListener('keydown',this.onKey);
      document.removeEventListener('pointerdown',this.onPointer);
      window.removeEventListener('scroll',this.onScroll);
      window.removeEventListener('resize',this.onResize);
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('cb-catalogue-mobile-open');
    }
  }
  customElements.define('cb-visual-catalogue',VisualCatalogue);
})();


(()=>{const init=()=>{const catalogue=document.querySelector('cb-visual-catalogue');const compact=document.querySelector('[data-bf-catalogue-host]');const mount=compact||document.querySelector('#HeaderNavigation');if(!catalogue||!mount)return;const position=()=>{const target=compact|| (matchMedia(`(min-width:${bfDesktopMin}px)`).matches?mount:document.body);if(catalogue.parentElement!==target)target.append(catalogue);};position();window.addEventListener('resize',position,{passive:true});document.documentElement.classList.add('bf-nav-ready');document.addEventListener('click',event=>{const toggle=event.target.closest('[data-mobile-menu]');if(toggle&&matchMedia(`(max-width:${bfDesktopMin-1}px)`).matches){event.preventDefault();event.stopImmediatePropagation();catalogue.openMobile();}},true);};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();})();

const search=document.querySelector('.bf-compact-header__search');if(search){search.addEventListener('toggle',()=>{if(search.open){document.querySelector('cb-visual-catalogue')?.closeDesktop(false);search.querySelector('input[type=search]')?.focus();}});document.addEventListener('keydown',event=>{if(event.key==='Escape'&&search.open){search.open=false;search.querySelector('summary').focus();}});document.addEventListener('pointerdown',event=>{if(search.open&&!search.contains(event.target))search.open=false;});}
})();
